// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e96cad3a57ea9cb2","5285":"cf262985659386a0"}[chunkId] + ".css";
};